import requestor from "shared/service/requestor";

export default class CommentApi {
  all = ({ courseId, lessonId }, clientId, modelTypeId) =>
    requestor.get("/course/comment_all", {
      course_id: courseId,
      lesson_id: lessonId,
      client_id: clientId,
      model_type_id: modelTypeId,
    });

  new = ({ courseId, lessonId }, content, parentId, modelTypeId, modelId, clientId) =>
    requestor.post("/course/comment_new", {
      course_id: courseId,
      lesson_id: lessonId,
      Comment: {
        content: content,
        parent_id: parentId,
        model_type_id: modelTypeId,
        model_id: modelId,
        client_id: clientId,
      },
    });

  remove = ({ courseId, lessonId }, commentId) =>
    requestor.delete("/course/comment_delete", {
      course_id: courseId,
      lesson_id: lessonId,
      id: commentId,
    });
}
